import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
	dsn: environment.sentryDSN,
	environment: environment.sentryEnvironment,
	sendDefaultPii: !environment.production,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// Tracing
	tracesSampleRate: 1.0,
	tracePropagationTargets: ['localhost', environment.api],
	// Session Replay
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 1.0,
	// Enable sending logs to Sentry
	enableLogs: true,
	enabled: !!environment.sentryDSN,
});

if (environment.production) {
	enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch(err => console.error(err));
});
